export enum NEW_RELIC_EVENT {
  PRINT_BOARDING_PASS = 'print_boarding_pass',
  REPRINT_BOARDING_PASS = 'reprint_boarding_pass',
  PRINT_ERROR = 'print_error',
  SEAT_PURCHASE = 'seat_purchase',
  SEAT_ADD_TO_CART = 'seat_add_to_cart',
  SEAT_PURCHASE_ERROR = 'seat_purchase_error',
  LOOK_UP_PNR_SUCCESS = 'lookup_pnr_success',
  LOOK_UP_PNR_ERROR = 'lookup_pnr_error',
  CARRY_ON_ADD_TO_CART = 'carry_on_add_to_cart',
  CARRY_ON_PAID = 'carry_on_paid',
  CARRY_ON_ERROR = 'carry_on_error',
  LOOK_UP_PNR_SCANNED_SUCCESS = 'lookup_pnr_scanned_success',
  LOOK_UP_PNR_SCANNED_ERROR = 'lookup_pnr_scanned_error',
  GET_RESERVATION = 'get_reservation',
  ELIGIBILITY = 'eligibility',
  BP_ELIGIBILITY = 'bording_pass_eligibility',
  PASSENGER_INFO = 'passenger_info',
  DOCUMENTS = 'documents',
  ADDON_5KG_ADD_TO_CART = 'addon_5kg_add_to_cart',
  ADDON_5KG_ERROR_ADD_TO_CART = 'addon_5kg_error_add_to_cart',
  ADDON_5KG_PURCHASE = 'addon_5kg_purchase',
  BOARDING_PASS_FALLBACK_ACTIVATED = 'boarding_pass_fallback_activated',
  BOARDING_PASS_SEGMENTS_FALLBACK = 'boarding_pass_segments_fallback',
  BOARDING_PASS_PASSENGERS_EMPTY = 'boarding_pass_passengers_empty',
  BOARDING_PASS_PASSENGER_ID_EMPTY = 'boarding_pass_passenger_id_empty',
  KIOSK_ADDRESS_AUTOCOMPLETE_INIT = 'kiosk_address_autocomplete_init',
  KIOSK_ADDRESS_AUTOCOMPLETE_RESEARCH_INIT = 'kiosk_address_autocomplete_research_init',
  KIOSK_ADDRESS_AUTOCOMPLETE_SELECTION = 'kiosk_address_autocomplete_selection',
  KIOSK_ADDRESS_SAVE = 'kiosk_address_save',
  KIOSK_ADDRESS_SCREEN_TIME = 'kiosk_address_screen_time',
  KIOSK_ADDRESS_AUTOCOMPLETE_SEARCH = 'kiosk_address_autocomplete_search',
  ADDON_5KG_PAID = 'addon_5kg_paid',
  ADDON_5KG_PAYMENT_ERROR = 'addon_5kg_payment_error',
  IROPS_DISCLAIMER_SHOWN = 'irops_disclaimer_shown',
  BAG_PRICE_ZERO_DETECTED = 'bag_price_zero_detected',
  KIOSK_UK_UPT_DETECTED = 'kiosk_uk_upt_detected',
  KIOSK_UK_UPT_RETRY_BLOCKED = 'kiosk_uk_upt_retry_blocked',
  KIOSK_UK_UPT_RESOLVED = 'kiosk_uk_upt_resolved',
  // Seat metrics
  SEAT_SELECTION_AVAILABLE = 'seat_selection_available',
  SEAT_ASSIGNATION_SUCCESS = 'seat_assignation_success',
  SEAT_ASSIGNATION_ERROR = 'seat_assignation_error',
  // Upgrade metrics
  UPGRADE_AVAILABLE = 'upgrade_available',
  UPGRADE_PURCHASE_SUCCESS = 'upgrade_purchase_success',
  UPGRADE_PURCHASE_ERROR = 'upgrade_purchase_error',
  UPGRADE_SEAT_ASSIGNATION_SUCCESS = 'upgrade_seat_assignation_success',
  UPGRADE_SEAT_ASSIGNATION_ERROR = 'upgrade_seat_assignation_error',
  ARU_EXPERIENCE_SHOWN = 'aru_experience_shown',
  ARU_FLIGHT_ACCEPTED = 'aru_flight_accepted',
  ARU_FLIGHT_CHANGED = 'aru_flight_changed',
  DEVICE_CONNECTED = 'device_connected',
  DEVICE_DISCONNECTED = 'device_disconnected',
  DEVICE_ERROR = 'device_error',
  DEVICE_OPERATION_TIME = 'device_operation_time',
  PASSPORT_VALIDATION = 'passport_validation',
  BAGS_LIMIT_EXCEEDED = 'bags_limit_exceeded',
  BAG_INSURANCE_OFFER_AVAILABLE = 'bag_insurance_offer_available',
  BAG_INSURANCE_MODAL_AVAILABLE = 'bag_insurance_modal_available',
  BAG_INSURANCE_ADD = 'bag_insurance_add',
  BAG_INSURANCE_PAYMENT = 'bag_insurance_payment',
  KIOSK_PASSENGER_ID_RETRY_ATTEMPTED = 'kiosk_passenger_id_retry_attempted',
  KIOSK_PASSENGER_ID_RETRY_SUCCESS = 'kiosk_passenger_id_retry_success',
  KIOSK_PASSENGER_ID_RETRY_FAILURE = 'kiosk_passenger_id_retry_failure',
  CHUBB_FLOW_AVAILABLE = 'chubb_flow_available',
  CHUBB_PRODUCTS_VIEWED = 'chubb_products_viewed',
  CHUBB_PRODUCT_SELECTED = 'chubb_product_selected',
  CHUBB_ESIM_SELECTED = 'chubb_esim_selected',
  CHUBB_PURCHASE_SUCCESS = 'chubb_purchase_success',
  CHUBB_PURCHASE_ERROR = 'chubb_purchase_error',
  FEM_MODAL_EVALUATION = 'fem_modal_evaluation',
}

export enum DEVICE {
  PINPAD = 'PINPAD',
  ATB_PRINTER = 'ATB_PRINTER',
  BAGTAG_PRINTER = 'BAGTAG_PRINTER',
}

export enum DEVICE_ERROR_CODE {
  DECLINED = 'DECLINED',
  FAILURE = 'FAILURE',
  CANCEL = 'CANCEL',
  STATUS_305 = 'STATUS_305',
  PECTAB_FAILED = 'PECTAB_FAILED',
  TICKET_FAILED = 'TICKET_FAILED',
  BAGTAG_FAILED = 'BAGTAG_FAILED',
}

export enum METRIC_NAME {
  KIOSK_AM = 'KIOSK_AM',
}

export enum CHANNEL {
  AM = 'AM',
}

export enum CHECK_IN_TYPE {
  SEAMLESS = 'seamless',
  SABRE = 'sabre',
  UNKNOWN = 'unknown',
}

export enum CHECK_IN_LEGS_TYPE {
  ALL_SEAMLESS = 'all_seamless',
  ALL_SABRE = 'all_sabre',
  MIXED = 'mixed',
  UNKNOWN = 'unknown',
}

export enum RESPONSE_STATUS {
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum PAX_DOCUMENTS_STATUS {
  INCOMPLETE = 'incomplete',
  COMPLETED = 'completed',
  ENTER = 'enter',
  EXIT = 'exit',
}

export enum ADDRESS_STATUS {
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export enum ADDRESS_CAPTURE_MODE {
  AUTOCOMPLETE = 'autocomplete',
  MANUAL = 'manual',
}
